import { Module, ActionContext } from 'vuex'
import { RootState, IntegrationsState } from './state_models'

export const integrations: Module<IntegrationsState, RootState> = {
  namespaced: true,
  state: { integrations: undefined, locationId: undefined, showGBPDeprecationWarning: true },
  getters: {
    getByLocationId: (
      state: IntegrationsState,
      getters: any,
      rootState: RootState,
      rootGetters: any
    ) => {
      return (locationId: string) =>
        state.locationId === locationId ? state.integrations : {}
    },
    shouldShowBanner: (
      state: IntegrationsState,
    ) => {
      return state.showGBPDeprecationWarning;
    }
  },
  mutations: {
    set: (state: IntegrationsState, payload) => {
      state.locationId = payload.locationId
      state.integrations = payload.integrations
    },
    toggleGBPWarningBanner: (state: IntegrationsState, showAlert) => {
			if (showAlert) {
        document.getElementsByTagName('body')[0].classList.add('with-GBP');
      } else {
				document.getElementsByTagName('body')[0].classList.remove('with-GBP');
			}
			state.showGBPDeprecationWarning = showAlert;
    },
  },
  actions: {
    set(context: ActionContext<IntegrationsState, RootState>, payload) {
      context.commit('set', payload)
    },
  },
}
